import React, { useState, useEffect } from "react";
import Wrapper from "../../UI/Wrapper";
import image1 from "../../../Icons/LeadDataImage1.png";
import image2 from "../../../Icons/Mask group.png";
import image3 from "../../../Icons/Maskgroup2.png";
import image4 from "../../../Icons/Maskgroup4.png";
import image5 from "../../../Icons/Maskgroup5.png";
import image6 from "../../../Icons/Maskgroup6.png";
import image7 from "../../../Icons/Maskgroup7.png";
import image8 from "../../../Icons/Maskgroup8.png";
import image9 from "../../../Icons/Maskgroup9.png";
import icon_user from "../../../Icons/icon_user.png";
import axios from "axios";
import Card from "../../../components/DashboardComponents/Card/Card";
import TotalBookingAmount from "../../../components/DashboardComponents/TotalBookingAmount/TotalBookingAmount";
import { DateRangePicker } from "react-date-range";

import dog from "../../../images/Dog.jpg";
import cat from "../../../images/cat (1).jpg";
import other from "../../../images/cat (2).jpg";

import icon1 from "../../../Icons/CardIcon1.png";
import icon2 from "../../../Icons/icon2.png";
import icon3 from "../../../Icons/icon3.png";

import icon4 from "../../../Icons/icon4.png";

// import "../LeadData/LeadData.css";
import { Height } from "@mui/icons-material";

const LeadDataOps = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [leadDataResponseOps, setLeadDataResponseOps] = useState([]);
  const [activeUsersResponse, setActiveUsersResponse] = useState([]);
  const [initialLeadData, setInitialLeadData] = useState([]);

  function getLeadData() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    let startdate = formatDate(selectionRange.startDate);

    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = "";
      enddate = "";
    }

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/getdashboarddetailOps?startDate=${startdate}&enddate=${enddate}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setLeadDataResponseOps(response.data.data);           
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }
  function clearFilter() {
    setDateRange("Custom Dates");
    setLeadDataResponseOps(initialLeadData); // Reset to initial data
  }

  const [isOpen, setIsOpen] = useState(false);
  const [dateRange, setDateRange] = useState("Custom Dates");
  const togglePicker = () => {
    setDateRange(
      formatDate(selectionRange.startDate) +
      " - " +
      formatDate(selectionRange.endDate)
    );
    setIsOpen(!isOpen);
  };

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const handleSelect = (ranges) => {
    // ranges contains an object with startDate and endDate
    setSelectionRange(ranges.selection);
  };

  const clearDateRange = () => {
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
  };

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}userget/getdashboarddetailOps?startDate=&enddate=`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {
            setLeadDataResponseOps(response.data.data);          
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  return (
    <>
      {/* <div className="filterdataDiv"> */}
      <div
        className="content-container-LeadList innerConatiner"
        style={{ overflowX: "clip" }}
      >
        <div className="container-fluid" style={{ marginTop: "3rem" }}>
          <div style={{ display: "flex" }}>
            <div
              className=" headerButton"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                gap: "10px",
                // justifyContent: "left",
                height: "69px",
                paddingBottom: "3px",
              }}
            >
              <div className="allFilterButtons">
                <div className="filter-icon">
                  <img
                    src={require("../../../Icons/filterIcon.png")}
                    alt="filter"
                  />
                  FILTER
                </div>
                <div style={{ paddingTop: "6px" }}>
                  <span>
                    Compare{" "}
                    <hr
                      style={{
                        width: "1px",
                        height: "20px", // Adjust height to match surrounding elements
                        backgroundColor: "black",
                        border: "none",
                        transform: "none",
                        position: "relative",
                        marginLeft: "92px",
                        marginTop: "-21px", // No need to rotate since it's a vertical line
                      }}
                    />
                  </span>
                </div>

                <div>
                  <button
                    style={{
                      marginBottom: "1rem",
                      width: "12rem",
                      height: "2.5rem",
                      borderRadius: "0.5rem",
                      fontSize: "13px",
                    }}
                    onClick={togglePicker}
                  >
                    {" "}
                    <b> {dateRange}</b>
                  </button>
                  {isOpen && (
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 999,
                        border: "solid 1px black",
                        marginLeft: "-13pc",
                        width: "35pc",
                        background: "white",
                      }}
                    >
                      <DateRangePicker
                        ranges={[selectionRange]}
                        onChange={handleSelect}
                      />
                      <button
                        onClick={clearDateRange}
                        style={{
                          marginBottom: "1rem",
                          width: "5rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          position: "relative",
                          top: "1px",
                          left: "22pc",
                          color: "red",
                          border: "none",
                        }}
                      >
                        Reset
                      </button>
                      <button
                        style={{
                          marginBottom: "1rem",
                          width: "7rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          position: "relative",
                          top: "1px",
                          left: "22pc",
                          backgroundColor: "#5B489D",
                          color: "White",
                        }}
                        onClick={togglePicker}
                      >
                        Done
                      </button>
                    </div>
                  )}
                </div>
                <div>
                  <div
                    className="fafilterApply"
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <div
                      className="Leadlist-filter"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <button onClick={getLeadData} className="">
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    className="fafilterresetApply"
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <div
                      className="Leadlist-filter-clear"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <button onClick={clearFilter} className="">
                        Clear Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="right-div"
                style={{
                  border: "1.5px solid #0C9800",
                  borderRadius: "7.5px",
                  padding: "5px",
                  width: "170px",
                  paddingLeft: "28px",
                  height: "36px",
                }}
              >
                <img
                  src={icon_user}
                  style={{
                    height: "15px",
                    width: "15px",
                    marginLeft: "-15px",
                  }}
                  alt="icon"
                />
                Active Users
                <div
                  style={{
                    height: "34px",
                    width: "35px",
                    backgroundColor: "#0C9800",
                    position: "absolute",
                    borderRadius: "7.5px",
                    marginLeft: "6.6rem",
                    marginTop: "-1.8rem",
                  }}
                >
                  {leadDataResponseOps.map((item) => (
                    <span>
                      <h5
                        style={{
                          padding: "5px 5px 5px 13px",
                          color: "rgb(255, 255, 255)",
                        }}
                      >
                        {item.active_users}
                      </h5>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: "22px",
        }}
      >
        <div>
          <h3 style={{ marginBottom: "2rem", fontWeight: "bold" }}>
            Dashboard (Operation)
          </h3>
        </div>
        <div className="directionThreeDivs">
          <div
            class="left-div"
            style={{
              display: "flex",
              flexDirection: "row",
              height: "38px",
            }}
          >
            <div
              style={{
                border: "1px solid black",
                borderRadius: "7.5px",
                padding: "5px",
                width: "100px",
                paddingLeft: "28px",
                marginLeft: "4px",
              }}
            >
              <span class="bluedot"></span>
              Total
            </div>
            <div
              style={{
                border: "1px solid black",
                borderRadius: "7.5px",
                padding: "5px",
                width: "110px",
                paddingLeft: "28px",
                marginLeft: "10px",
              }}
            >
              <span class="greendot"></span>
              Today's
            </div>
          </div>
        </div>
      </div>

      <div style={{ width: "100%", marginBottom: "1rem" }}>
        <div className="c-containerFirst">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#5B489D", width: "4rem" }}
              >
                <img
                  className="imgdatatag"
                  src={image1}
                  alt="leadImage"
                  style={{
                    width: "3em",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }}>{item.total_Order}</h3>
                ))}
                <span>Total Order</span>
              </div>
            </div>

            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#FA9A0B", width: "4rem" }}
              >
                <img
                  src={image2}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }}>
                    {item.total_untouched_order}
                  </h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>Total Untouched Orders</span>
              </div>
            </div>

            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#DD4477", width: "4rem" }}
              >
                <img
                  src={image3}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }}>{item.total_open_order}</h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>Total Open Orders</span>
              </div>
            </div>

            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#44DDDD", width: "4rem" }}
              >
                <img
                  src={image3}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }}>{item.total_execution}</h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>Total Executions</span>
              </div>
            </div>
          </div>

          <br />

          <div
            className="row"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#0C9800", width: "4rem" }}
              >
                <img
                  src={image4}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }}>{item.total_cancelled}</h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>Total Cancelled</span>
              </div>
            </div>

            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#ED1F24", width: "4rem" }}
              >
                <img
                  src={image5}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }}>{item.total_abandoned}</h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>Total Abandon</span>
              </div>
            </div>

            {/*------------------------add below for Missed Execution-----Start----------------------*/}
            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#800080", width: "4rem" }}
              >
                <img
                  src={image5}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }}>{item.missed_execution}</h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>Missed Execution</span>
              </div>
            </div>


            {/*------------------------ Missed Execution-----End----------------------*/}

            <div
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h3></h3>

              <span></span>
            </div>
          </div>
        </div>
      </div>

      <div style={{ width: "100%", marginBottom: "1rem" }}>
        <div
          className="c-containerFirst"
          style={{ width: "100%", borderColor: "Green" }}
        >
          <div
            className="row"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#5B489D", width: "4rem" }}
              >
                <img
                  className="imgdatatag"
                  src={image1}
                  alt="leadImage"
                  style={{
                    width: "3em",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 key={item.id}>{item.today_Order}</h3>
                ))}
                <span>Today's Order</span>
              </div>
            </div>
            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#FA9A0B", width: "4rem" }}
              >
                <img
                  src={image2}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }} key={item.id}>
                    {item.today_untouched_order}
                  </h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>
                  Today's Untouched Orders
                </span>
              </div>
            </div>
            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#DD4477", width: "4rem" }}
              >
                <img
                  src={image3}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }} key={item.id}>
                    {item.today_open_order}
                  </h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>Today's Open Orders</span>
              </div>
            </div>
            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#44DDDD", width: "4rem" }}
              >
                <img
                  src={image3}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }} key={item.id}>
                    {item.today_execution}
                  </h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>Today's Executions</span>
              </div>
            </div>
          </div>

          <br />

          <div
            className="row"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#0C9800", width: "4rem" }}
              >
                <img
                  src={image4}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }} key={item.id}>
                    {item.today_cancelled}
                  </h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>Today's Cancelled</span>
              </div>
            </div>
            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#ED1F24", width: "4rem" }}
              >
                <img
                  src={image5}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }} key={item.id}>
                    {item.today_abandoned}
                  </h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>Today's Abandon Order</span>
              </div>
            </div>
            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                className="imageStyle"
                style={{ background: "#B544DD", width: "4rem" }}
              >
                <img
                  src={image7}
                  alt="leadImage"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div style={{ marginLeft: "1rem", textAlign: "left" }}>
                {leadDataResponseOps.map((item) => (
                  <h3 style={{ color: "#6A6A6A" }} key={item.id}>
                    {item.today_Order}
                  </h3>
                ))}
                <span style={{ color: "#6A6A6A" }}>Today's Task</span>
              </div>
            </div>
            <div
              className="col"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <span></span>
            </div>
          </div>
        </div>
      </div>

      <div style={{ width: "100%", display: "flex", height: "20rem" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "9rem",
            padding: "2rem",
            backgroundColor: "white",
            width: "50%",
            border: "3px solid blue",
            height: "21.3rem",

            borderRadius: "8px 8px 8px 8px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              marginLeft: "2rem",
            }}
          >
            <img
              src={dog}
              style={{ width: "100px", marginBottom: "1rem" }}
              alt="Dog"
            />
            {leadDataResponseOps.map((item) => (
              <h3
                style={{
                  color: "#6A6A6A",
                  marginBottom: "1rem",
                  fontSize: "36px",
                }}
                key={item.id}
              >
                {item.total_dogs}
              </h3> // Add a unique key
            ))}
            <span style={{ color: "#6A6A6A", fontSize: "17px" }}>
              Dog Relocation
            </span>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <img src={cat} style={{ width: "100px" }} alt="Cat" />
            {leadDataResponseOps.map((item) => (
              <h3
                style={{
                  color: "#6A6A6A",
                  marginBottom: "1rem",
                  fontSize: "36px",
                }}
                key={item.id}
              >
                {item.total_cats}
              </h3>
            ))}
            <span style={{ color: "#6A6A6A", fontSize: "17px" }}>
              Cat Relocation
            </span>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              marginRight: "1rem",
            }}
          >
            <img src={other} style={{ width: "100px" }} alt="Other Animals" />
            {leadDataResponseOps.map((item) => (
              <h3
                style={{
                  color: "#6A6A6A",
                  marginBottom: "1rem",
                  fontSize: "36px",
                }}
                key={item.id}
              >
                {item.total_other_animals}
              </h3>
            ))}
            <span style={{ color: "#6A6A6A", fontSize: "17px" }}>
              Other Animal Relocation
            </span>
          </div>
        </div>

        <div style={{ marginLeft: "2rem", height: "10rem" }}>
          <div style={{}}>
            <div style={{}}>
              <table style={{ height: "8rem" }}>
                <tr style={{}}>
                  <td style={{}}>
                    {leadDataResponseOps.map((item) => (
                      <Card
                        style={{}}
                        heading="Todays follow up"
                        value={item.todays_follow_up}
                        background="#0C9800"
                        borderRadius="10px"
                        icon={icon1}
                        height="10rem"
                      />
                    ))}
                  </td>
                  <td style={{ paddingLeft: "1rem", width: "27rem" }}>
                    {leadDataResponseOps.map((item) => (
                      <Card
                        heading="Missed follow up"
                        value={item.missed_follow_up}
                        background="#DD4477"
                        borderRadius="10px"
                        icon={icon2}
                        height="10rem"
                      />
                    ))}
                  </td>
                </tr>
                <br />
                <tr>
                  <td style={{ width: "27rem" }}>
                    {leadDataResponseOps.map((item) => (
                      <Card
                        heading="Todays update"
                        value={item.todays_update}
                        background="#0099C6"
                        borderRadius="10px"
                        icon={icon3}
                        height="10rem"
                      />
                    ))}
                  </td>
                  <td style={{ paddingLeft: "1rem", width: "27rem" }}>
                    {leadDataResponseOps.map((item) => (
                      <Card
                        heading="Execution Ratio"
                        value={item.execution_ration}
                        background="#FA9A0B"
                        borderRadius="10px"
                        icon={icon4}
                      />
                    ))}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
      .filter-icon{
      box-shadow: 0 1px 8px rgba(0, 0, 0, 0.25);
    /* border: 1px solid black; */
    width: 95px;
    height: 47px;
    position: relative;
    padding: 13px;
    padding-top: 15px;
    background-color: white;
    border-radius: 9px;
    top: -4px;
    left: -15px;
      }
      `}</style>
    </>
  );
};

export default LeadDataOps;
